import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { BuyerInfo, ENocMLookUp, ENocMLookupData, Mode, } from "../../enocapi/entities";
import TextInputField from "@eres/forms-web/TextInputField";
import FixedEidInput from "@my-dld/components/FixedEidInput";
import { EidStateFormatter } from "../Login/owner/EID";
import { getAfterDate, getPreviousDate, populateENocMLookup } from "../../enocapi/services";
import PickerInput from "@my-dld/components/Form/PickerInput";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { serverDateConverter } from "@my-dld/utils/LookupUtil";
import DateInputField from "@eres/forms-web/DateInputField";
import { ErrorContainer } from "@eres/forms";


interface ENOCLookupState {
	Countries: ENocMLookupData[];
	Genders: ENocMLookupData[];
}

interface Prop extends BuyerInfo {
	isCompany?: boolean;
	onDNRD: ( buyer: BuyerInfo ) => void;
	onSwitch: ( isUAEResident: boolean ) => void;
	uaeResidenceVerified?: boolean,
	resetAll: boolean,
}

interface State extends ENOCLookupState, BuyerInfo {
	errorContainer: ErrorContainer;
}

export default class PersonInfo extends Component<Prop, State> {
	constructor( props: Prop ) {
		super( props );
		this.state = {
			Countries: [],
			Genders: [],
			errorContainer: {},
			...this.props,
		};
		// this.onSwitch(this.state.isUAEResident!);
	}

	componentDidMount(): void {
		populateENocMLookup( ENocMLookUp.COUNTRIES, this );
		populateENocMLookup( ENocMLookUp.GENDER, this, ( values ) => {
			if ( values && values.length > 0 ) {
				const data: BuyerInfo = this.state;
				if ( data.genderId ) {
					const gender = values.find( ( val: ENocMLookupData ) => {
						return val.identity === data.genderId;
					} );
					if ( gender ) {
						this.setState( { gender: gender } );
					}
				}
			}
		} );
	}

	componentDidUpdate( prevProps: Readonly<Prop>, prevState: Readonly<State>, snapshot?: any ) {
		if ( prevProps.resetAll !== this.props.resetAll ) {
			this.setState( {
				...this.state,
				...this.props,
			} );
		}
		if ( prevProps.genderId !== this.props.genderId && this.state.Genders && this.state.Genders.length > 0 ) {
			const gender = this.state.Genders.find( ( val: ENocMLookupData ) => {
				return val.identity === this.state.genderId;
			} );
			if ( gender ) {
				this.setState( { gender: gender } );
			}
		}
	}

	render() {
		let data: BuyerInfo = this.state;
		const isCompany = this.props.isCompany;
		const uaeResidenceVerified = this.props.uaeResidenceVerified;
		const kvProp = { inputClassName: "form-control", holder: this, containerClassName: "col-md-6 form-group" };
		const isResubmit = data.mode === Mode.EDIT;
		const isView = data.mode === Mode.VIEW;
		const errorContainer = this.state.errorContainer;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			errorManager: defaultErrorManager,
		};
		const disableVerify = data.emiratesID ? data.emiratesID.length < 15 : true;
		return <React.Fragment>
			<div className="row">
				<div className="col-md-6 form-group">
					<label>{ Strings.uae_resident }</label>
					<div>
						<div className="btn-group btn-toggle btn-custom-toggle">
							<button
								disabled={ isResubmit || isView || uaeResidenceVerified } type="button"
								className={ data.isUAEResident ? "btn active" : "btn" }
								onClick={ () => this.onSwitch( true ) }>{ Strings.yes }</button>
							<button
								disabled={ isResubmit || isView || uaeResidenceVerified } type="button"
								className={ data.isUAEResident ? "btn" : "btn active" }
								onClick={ () => this.onSwitch( false ) }>{ Strings.no }</button>
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				{
					data.isUAEResident &&
					<div className="col-md-4">
						<FixedEidInput
							disabled={ isResubmit || isView || uaeResidenceVerified }
							containerClassName={ "input-group form-group" }
							extraInputClassName={ "field-ar eid-with-button" }
							id={ "emiratesID" }
							label={ Strings.emirates_id_number }
							required={ true }
							holder={ this }
							error={ errorContainer.emiratesID }
							placeHolder={ "784-XXXX-XXXXXX-X" }
							stateFormatter={ EidStateFormatter }
						>
							<div className="input-group-append">
								<button
									disabled={ isResubmit || isView || disableVerify || uaeResidenceVerified } className="btn btn_1" type="button"
									onClick={ () => {
										this.props.onDNRD( this.state );
									} }>{ Strings.verify }</button>
							</div>
						</FixedEidInput>
					</div>
				}
				{
					data.isUAEResident &&
					<div className="col-md-4">
						<DateInputField
							{ ...filedProps }
							label={ Strings.expiry_date }
							id={ "emiratesIdExpiry" }
							required={ true }
							containerClassName="form-group position-relative"
							valueConverter={ serverDateConverter }
							extraOpts={ {
								minDate: data.emiratesIdExpiry ? data.emiratesIdExpiry?.asDate() : getAfterDate(),
							} }
							disabled={ isView }
						/>
					</div>
				}
				<div className="col-md-4">
					<TextInputField
						{ ...filedProps }
						id={ isCompany ? "ManagerNameEn" : "PersonNameEn" }
						required={ true }
						containerClassName="form-group"
						label={ Strings.english_name }
						error={ isCompany ? errorContainer.ManagerNameEn : errorContainer.PersonNameEn }
						disabled={ isView ? true : ( data.isUAEResident ) }
					/>
				</div>
				<div className="col-md-4">
					<TextInputField
						{ ...filedProps }
						id={ isCompany ? "ManagerNameAr" : "PersonNameAr" }
						required={ true }
						containerClassName="form-group"
						label={ Strings.arabic_name }
						error={ isCompany ? errorContainer.ManagerNameAr : errorContainer.PersonNameAr }
						disabled={ isView ? true : ( data.isUAEResident ) }
					/>
				</div>
				<div className="col-md-4">
					<PickerInput
						{ ...kvProp }
						label={ Strings.gender }
						id={ "gender" }
						items={ this.state.Genders }
						toIdentifier={ ( item: ENocMLookupData ) => item.identity + "" }
						containerClassName="form-group field-style select-control"
						required={ true }
						error={ errorContainer.gender }
						onValueChange={ ( gender?: ENocMLookupData ) => {
							this.setState( { genderId: gender?.identity } );
						} }
						disabled={ isView }
					/>
				</div>
				<div className="col-md-4">
					<TextInputField
						{ ...filedProps }
						id={ "passportNumber" }
						required={ true }
						containerClassName="form-group"
						label={ Strings.passport_number }
						disabled={ isView }
					/>
				</div>
				<div className="col-md-4">
					<PickerInput
						{ ...kvProp }
						label={ Strings.nationality }
						id={ "nationality" }
						items={ this.state.Countries }
						toIdentifier={ ( item: ENocMLookupData ) => item.identity + "" }
						containerClassName="form-group field-style select-control"
						required={ true }
						error={ errorContainer.nationality }
						disabled={ isView ? true : ( data.isUAEResident ) }
					/>
				</div>
				<div className="col-md-4">
					<TextInputField
						{ ...filedProps }
						id={ "passportIssuedBy" }
						required={ true }
						containerClassName="form-group"
						label={ Strings.passport_issue_place }
						disabled={ isView }
					/>
				</div>
				<div className="col-md-4">
					<DateInputField
						{ ...filedProps }
						required={ true }
						label={ Strings.passport_issue_date }
						id={ "startDate" }
						containerClassName="form-group position-relative"
						valueConverter={ serverDateConverter }
						disabled={ isView }
						extraOpts={ {
							maxDate: getPreviousDate(),
						} }
					/>
				</div>
				<div className="col-md-4">
					<DateInputField
						{ ...filedProps }
						required={ true }
						label={ Strings.passport_exp_date }
						id={ "endDate" }
						containerClassName="form-group position-relative"
						valueConverter={ serverDateConverter }
						extraOpts={ {
							minDate: data.endDate ? data.endDate?.asDate() : getAfterDate(),
						} }
						disabled={ isView }
					/>
				</div>
				<div className="col-md-4">
					<TextInputField
						{ ...filedProps }
						id={ "birthPlace" }
						required={ true }
						containerClassName="form-group"
						label={ Strings.birth_place }
						disabled={ isView }
					/>
				</div>
				<div className="col-md-4">
					<DateInputField
						{ ...filedProps }
						required={ true }
						label={ Strings.birthdate }
						id={ "birthDate" }
						containerClassName="form-group position-relative"
						valueConverter={ serverDateConverter }
						extraOpts={ {
							maxDate: getPreviousDate(),
						} }
						disabled={ isView ? true : ( data.isUAEResident ) }
					/>
				</div>
				<div className="col-md-4">
					<TextInputField
						{ ...filedProps }
						id={ "mobile" }
						required={ true }
						containerClassName="form-group"
						label={ Strings.mobile_number }
						disabled={ isView }
					/>
				</div>
				<div className="col-md-4">
					<TextInputField
						{ ...filedProps }
						id={ "email" }
						required={ true }
						disabled={ isView }
						containerClassName="form-group"
						label={ Strings.email }
					/>
				</div>
			</div>
		</React.Fragment>;
	}

	onSwitch( isResident: boolean ) {
		this.setState( { isUAEResident: isResident } );
		this.props.onSwitch( isResident );
	}

	public getBuyerInfo(): BuyerInfo {
		const buyer = this.state;
		return {
			isUAEResident: buyer.isUAEResident,
			emiratesID: buyer.emiratesID,
			emiratesIdExpiry: buyer.emiratesIdExpiry,
			ManagerNameEn: buyer.ManagerNameEn,
			PersonNameAr: buyer.PersonNameAr,
			ManagerNameAr: buyer.ManagerNameAr,
			PersonNameEn: buyer.PersonNameEn,
			gender: buyer.gender,
			genderId: buyer.genderId,
			passportNumber: buyer.passportNumber,
			nationality: buyer.nationality,
			passportIssuedBy: buyer.passportIssuedBy,
			startDate: buyer.startDate,
			endDate: buyer.endDate,
			birthDate: buyer.birthDate,
			birthPlace: buyer.birthPlace,
			mobile: buyer.mobile,
			email: buyer.email,
		} as BuyerInfo;
	}
}
